var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldDoodleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_884_482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.9979 191.998C43.0679 191.998 -0.00214386 148.928 -0.00214386 95.9977C-0.00214386 43.0677 43.0679 -0.00231934 95.9979 -0.00231934C148.928 -0.00231934 191.998 43.0677 191.998 95.9977C191.998 148.928 148.928 191.998 95.9979 191.998ZM95.9979 1.76799C44.0315 1.76799 1.76816 44.0313 1.76816 95.9977C1.76816 147.964 44.0315 190.227 95.9979 190.227C147.964 190.227 190.228 147.942 190.228 95.9977C190.228 44.0537 147.964 1.76799 95.9979 1.76799Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M95.0182 191.998C79.0406 191.998 66.514 149.824 66.514 95.9977C66.514 42.1714 79.0182 -0.0022583 95.0182 -0.0022583C111.018 -0.0022583 123.522 42.1714 123.522 95.9977C123.522 149.824 110.996 191.998 95.0182 191.998ZM95.0182 1.76805C80.5196 1.76805 68.2843 44.9277 68.2843 95.9977C68.2843 147.068 80.5196 190.227 95.0182 190.227C109.517 190.227 121.752 147.068 121.752 95.9977C121.752 44.9277 109.494 1.76805 95.0182 1.76805Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M93.943 191.998C64.2288 191.998 40.0271 148.928 40.0271 95.9977C40.0271 43.0678 64.2063 -0.0022583 93.943 -0.0022583C123.68 -0.0022583 147.859 43.0678 147.859 95.9977C147.859 148.928 123.68 191.998 93.943 191.998ZM93.943 1.76805C65.1923 1.76805 41.7974 44.0314 41.7974 95.9977C41.7974 147.964 65.1923 190.227 93.943 190.227C122.694 190.227 146.089 147.942 146.089 95.9977C146.089 44.0538 122.694 1.76805 93.943 1.76805Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M95.7306 191.998C52.9295 191.998 18.0835 148.928 18.0835 95.9977C18.0835 43.0678 52.9295 -0.0022583 95.7306 -0.0022583C138.532 -0.0022583 173.378 43.0678 173.378 95.9977C173.378 148.928 138.554 191.998 95.7306 191.998ZM95.7306 1.76805C53.8931 1.76805 19.8762 44.0314 19.8762 95.9977C19.8762 147.964 53.9155 190.227 95.753 190.227C137.591 190.227 171.63 147.942 171.63 95.9977C171.63 44.0538 137.568 1.76805 95.7306 1.76805Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M95.9979 112.615C49.4545 112.615 -0.00211334 106.878 -0.00211334 96.2565C-0.00211334 85.6346 49.4545 79.8979 95.9979 79.8979C142.541 79.8979 191.998 85.6346 191.998 96.2565C191.998 106.878 142.541 112.615 95.9979 112.615ZM95.9979 81.6683C40.4685 81.6683 1.76819 89.3545 1.76819 96.2565C1.76819 103.158 40.4685 110.845 95.9979 110.845C151.527 110.845 190.228 103.158 190.228 96.2565C190.228 89.3545 151.527 81.6683 95.9979 81.6683Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_884_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldDoodleBlack);
export default __webpack_public_path__ + "static/media/worldDoodleBlack.29dca5573c40de1e82a40210978d0e7d.svg";
export { ForwardRef as ReactComponent };